import { useSearchParams } from "react-router-dom";
import Reveal from "@/components/feature/Reveal";
import Breadcrumb from "@/components/feature/Breadcrumb";
import { clinic } from "@/mocks/clinic";
import { priceTabs } from "@/mocks/priceTables";
import { ReserveButton } from "@/components/layout/ReserveButton";
import { LineButton } from "@/components/layout/LineButton";
import PricePanel from "./components/PricePanel";
import PriceTabs from "./components/PriceTabs";

export default function PricePage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const requested = searchParams.get("tab");
  const activeTab = priceTabs.find((tab) => tab.id === requested) ?? priceTabs[0];

  const handleChange = (id: string) => {
    setSearchParams({ tab: id }, { replace: true });
  };

  return (
    <>
      <section className="relative overflow-hidden border-b border-background-300/70 bg-background-50 pb-14 pt-28 md:pb-16 md:pt-36 lg:pt-40">
        <div
          aria-hidden
          className="pointer-events-none absolute -right-24 top-24 h-72 w-72 rounded-full bg-secondary-100/50 blur-3xl"
        />
        <div className="u-container relative">
          {/* 料金表：HOME ＞ 料金表（現在ページは非リンク） */}
          <Breadcrumb
            items={[
              { label: "HOME", href: "/", path: "/" },
              { label: "料金表", path: "/price" },
            ]}
          />

          <Reveal delay={100}>
            <div className="mt-10 max-w-2xl">
              <span className="en-eyebrow block text-[11px] text-secondary-700 md:text-[12px]">PRICE</span>
              <span className="mt-5 block h-px w-12 bg-accent-500" />
              <h1 className="mt-7 font-heading text-[32px] leading-[1.5] tracking-[0.02em] text-foreground-950 md:text-[44px]">
                料金表
              </h1>
              <p className="mt-7 text-[14px] leading-[2.2] text-foreground-700 md:text-[15px]">
                カテゴリごとに料金をご案内しています。カテゴリを切り替えてご確認ください。
              </p>
            </div>
          </Reveal>
        </div>
      </section>

      <section className="bg-background-50 py-14 md:py-16 lg:py-20">
        <div className="u-container">
          <PriceTabs tabs={priceTabs} activeId={activeTab.id} onChange={handleChange} />

          <div className="mt-12 md:mt-16">
            <PricePanel tab={activeTab} />
          </div>
        </div>
      </section>

      <section className="relative overflow-hidden bg-primary-700 py-20 md:py-24">
        <div
          aria-hidden
          className="pointer-events-none absolute -right-20 top-1/2 h-72 w-72 -translate-y-1/2 rounded-full border border-background-50/10"
        />
        <div className="u-container relative">
          <Reveal>
            <div className="mx-auto flex max-w-3xl flex-col items-center text-center">
              <span className="en-eyebrow text-[10px] text-accent-300 md:text-[11px]">
                CONTACT / RESERVATION
              </span>
              <h2 className="mt-7 font-heading text-[24px] leading-[1.6] text-background-50 md:text-[34px]">
                料金についてのご相談も、
                <br />
                お気軽にどうぞ。
              </h2>
              <p className="mt-7 max-w-xl text-[13px] leading-[2.2] text-background-200 md:text-sm">
                施術内容が決まっていない方も、まずはお気軽にご相談ください。料金を含め、分かりやすくご説明します。
              </p>

              <div className="mt-10 flex w-full flex-col items-stretch gap-3 sm:w-auto sm:flex-row sm:items-center">
                <ReserveButton className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-background-50 px-8 py-3.5 text-[14px] font-medium text-primary-700 transition-colors hover:bg-secondary-100">
                  <i className="ri-calendar-check-line text-base" aria-hidden />
                  WEB予約
                </ReserveButton>
                <LineButton className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/40 px-8 py-3.5 text-[14px] text-background-50 transition-colors hover:bg-background-50/10">
                  <i className="ri-line-fill text-base" aria-hidden />
                  LINEで相談
                </LineButton>
                <a
                  href={clinic.telHref}
                  className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md px-8 py-3.5 text-[14px] text-background-200 transition-colors hover:text-background-50"
                >
                  <i className="ri-phone-line text-base" aria-hidden />
                  電話する
                </a>
              </div>

              <p className="mt-8 text-[12px] tracking-wide text-background-200/80">
                {clinic.hours} ／ 渋谷駅近く
              </p>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}